import { useContext } from 'react'
import { FnsContext } from '@/features/forms-and-surveys/contexts/fns-context'

export function useFnsMode() {
  const { mode } = useContext(FnsContext)
  return mode
}
